import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { Webhook } from "@mui/icons-material";

/**
 * Webhook Trigger — Iniciar flow via HTTP externo.
 *
 * data.webhookPath: string — path unico do webhook (ex: "meu-flow-123")
 * data.webhookMethod: "POST" | "GET" (default: POST)
 * data.webhookAuth: "none" | "token" | "basic"
 * data.webhookToken: string — token de autenticacao (quando auth=token)
 *
 * URL gerada: {BACKEND_URL}/flowbuilder/webhook/{webhookPath}
 *
 * Saida: handle "a" (default) — dados do webhook ficam em ${webhook.body}
 */
const WebhookTriggerNode = memo(({ id, data, isConnectable, selected }) => {
  const path = data?.webhookPath || "";
  const method = data?.webhookMethod || "POST";
  const auth = data?.webhookAuth || "none";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Webhook />}
      title="Webhook Trigger"
      color="#D84315"
      bgColor="#FBE9E7"
      noTarget
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Method badge */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
        <span style={{
          background: method === "GET" ? "#2E7D32" : "#1565C0",
          color: "#fff", borderRadius: 4, padding: "2px 8px",
          fontSize: 10, fontWeight: 700, fontFamily: "monospace",
        }}>
          {method}
        </span>
        {auth !== "none" && (
          <span style={{
            background: "#F57C00", color: "#fff",
            borderRadius: 4, padding: "2px 6px",
            fontSize: 9, fontWeight: 700,
          }}>
            {auth === "token" ? "TOKEN" : "BASIC"}
          </span>
        )}
      </div>

      {/* Path preview */}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "5px 10px",
        fontSize: 11,
        fontFamily: "'Fira Code', monospace",
        color: "#555",
        wordBreak: "break-all",
      }}>
        <span style={{ color: "#999" }}>/webhook/</span>
        <span style={{ color: "#D84315", fontWeight: 600 }}>
          {path || "..."}
        </span>
      </div>
    </NodeWrapper>
  );
});

WebhookTriggerNode.displayName = "WebhookTriggerNode";
export default WebhookTriggerNode;
